/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AnyDataObjectId,
  ArrayDataObjectMetadataView,
  ArrayFieldsForTiebreaks,
  BatchRuleExecutionResult,
  CallerRef,
  CreateRuleDto,
  DataSource,
  Draft,
  DraftCreateRequest,
  DraftUpdateRequest,
  MapDataSourceArrayDataFieldTypeMetadata,
  MapDataSourceArrayDataObjectMetadataView,
  MapDraftIdWrappedDraft,
  MapRuleIdCreateRuleDto,
  MapRuleIdRuleView,
  MapString,
  MapUnderlyingMatchingConfigIdSalesforceCaseMatchingConfigView,
  MapUnderlyingMatchingConfigIdSalesforceContactMatchingConfigView,
  MapUnderlyingMatchingConfigIdSalesforceLeadMatchingConfigView,
  MapUnderlyingMatchingConfigIdSalesforceOpportunityMatchingConfigView,
  MapUnderlyingMatchingConfigIdSalesforceRelatedLeadMatchingConfigView,
  MaterializationResponse,
  MetadataForSalesforceL2A,
  MigrateToExplicitRequest,
  PaginatedResultDraftAndRule,
  PaginatedResultRuleView,
  PaginatedResultSalesforceCaseMatchingConfigView,
  PaginatedResultSalesforceChildMatchingConfigView,
  PaginatedResultSalesforceContactMatchingConfigView,
  PaginatedResultSalesforceLeadMatchingConfigView,
  PaginatedResultSalesforceOpportunityMatchingConfigView,
  PaginatedResultSalesforceRelatedLeadMatchingConfigView,
  PreviewBatchRuleExecutionRequest,
  PreviewMaterializationRequest,
  PreviewRuleExecutionRequest,
  QueryDraftsRequest,
  QueryRulesRequest,
  RuleBuilderVersion,
  RuleExecutionResult,
  RuleType,
  RuleView,
  SalesforceCaseMatchingConfigView,
  SalesforceChildMatchingConfigRequest,
  SalesforceChildMatchingConfigView,
  SalesforceContact2CaseMatchingConfigRequest,
  SalesforceContact2DuplicateContactConfigRequest,
  SalesforceContact2DuplicateLeadConfigRequest,
  SalesforceContact2OpportunityMatchingConfigRequest,
  SalesforceContactMatchingConfigView,
  SalesforceLead2AccountConfigRequest,
  SalesforceLead2AccountMatchingConfigView,
  SalesforceLead2CaseMatchingConfigRequest,
  SalesforceLead2DuplicateContactConfigRequest,
  SalesforceLead2DuplicateLeadConfigRequest,
  SalesforceLead2OpportunityMatchingConfigRequest,
  SalesforceLead2RelatedLeadMatchingConfigRequest,
  SalesforceLeadMatchingConfigView,
  SalesforceOpportunityMatchingConfigView,
  SalesforceProspect2ContactConfigRequest,
  SalesforceProspect2LeadConfigRequest,
  SalesforceRelatedLeadMatchingConfigView,
  UpdateRuleDto,
  UsageBulkRequestRes,
  UsageRequestRes,
  WrappedDraft,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "rules";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description attempts to find rule specified by the id
   *
   * @tags CRUD/Rules
   * @name FindRule
   * @request GET:/v1/tenant/{tenantId}/rule/{ruleId}
   * @secure
   */
  findRule = (
    tenantId: string,
    ruleId: string,
    query?: {
      /**
       * if present makes the request query for historical version of rule, specified by revision
       * @format int32
       */
      revision?: number;
      /**
       * if present allows the request to fallback on deleted version, ignored if revision provided
       * @default false
       */
      fallbackToDeletedIfNoRevision?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule/${ruleId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRule */
  findRulePathGetter = (
    tenantId: string,
    ruleId: string,
    query?: {
      /**
       * if present makes the request query for historical version of rule, specified by revision
       * @format int32
       */
      revision?: number;
      /**
       * if present allows the request to fallback on deleted version, ignored if revision provided
       * @default false
       */
      fallbackToDeletedIfNoRevision?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rule/${ruleId}`, query);

  /**
   * @description update rule for specified revision ONLY
   *
   * @tags CRUD/Rules
   * @name UpdateRule
   * @request PUT:/v1/tenant/{tenantId}/rule/{ruleId}
   * @secure
   */
  updateRule = (tenantId: string, ruleId: string, data: UpdateRuleDto, params: RequestParams = {}) =>
    this.request<
      RuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule/${ruleId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateRule */
  updateRulePathGetter = (tenantId: string, ruleId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/rule/${ruleId}`);

  /**
   * @description replace rule specified by the id
   *
   * @tags CRUD/Rules
   * @name ReplaceRule
   * @request POST:/v1/tenant/{tenantId}/rule/{ruleId}
   * @secure
   */
  replaceRule = (tenantId: string, ruleId: string, data: UpdateRuleDto, params: RequestParams = {}) =>
    this.request<
      RuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule/${ruleId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceRule */
  replaceRulePathGetter = (tenantId: string, ruleId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/rule/${ruleId}`);

  /**
   * @description deletes rule specified by the id
   *
   * @tags CRUD/Rules
   * @name DeleteRule
   * @request DELETE:/v1/tenant/{tenantId}/rule/{ruleId}
   * @secure
   */
  deleteRule = (
    tenantId: string,
    ruleId: string,
    query?: {
      /**
       * whether rule should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule/${ruleId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteRule */
  deleteRulePathGetter = (
    tenantId: string,
    ruleId: string,
    query?: {
      /**
       * whether rule should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rule/${ruleId}`, query);

  /**
   * @description query rule with provided filters
   *
   * @tags Queries
   * @name QueryRules
   * @request GET:/v1/tenant/{tenantId}/rule
   * @secure
   */
  queryRules = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * csv of $field(:$order)? <br>available fields: createdAt,updatedAt,ruleType, available orders: asc,desc
       * @minLength 1
       * @default "createdAt:desc"
       * @example "ruleType:asc,createdAt:desc"
       */
      orderBy?: string;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Is CS Admin" */
      name?: string;
      /** @example "NonOwnershipRule" */
      type?: RuleType;
      /**
       * describes subset of rule builder versions - flag has no impact on execution
       * @minItems 1
       * @default ["Default"]
       * @example ["Default","ExplicitV1"]
       */
      ruleBuilderVersion?: RuleBuilderVersion[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultRuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryRules */
  queryRulesPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * csv of $field(:$order)? <br>available fields: createdAt,updatedAt,ruleType, available orders: asc,desc
       * @minLength 1
       * @default "createdAt:desc"
       * @example "ruleType:asc,createdAt:desc"
       */
      orderBy?: string;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Is CS Admin" */
      name?: string;
      /** @example "NonOwnershipRule" */
      type?: RuleType;
      /**
       * describes subset of rule builder versions - flag has no impact on execution
       * @minItems 1
       * @default ["Default"]
       * @example ["Default","ExplicitV1"]
       */
      ruleBuilderVersion?: RuleBuilderVersion[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rule`, query);

  /**
   * @description creates rule
   *
   * @tags CRUD/Rules
   * @name CreateRule
   * @request POST:/v1/tenant/{tenantId}/rule
   * @secure
   */
  createRule = (
    tenantId: string,
    data: CreateRuleDto,
    query?: {
      /**
       * describes version of rule builder - flag has no impact on execution
       * @default "Default"
       * @example "ExplicitV1"
       */
      ruleBuilderVersion?: RuleBuilderVersion;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createRule */
  createRulePathGetter = (
    tenantId: string,
    query?: {
      /**
       * describes version of rule builder - flag has no impact on execution
       * @default "Default"
       * @example "ExplicitV1"
       */
      ruleBuilderVersion?: RuleBuilderVersion;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rule`, query);

  /**
   * @description attempts to find rule specified by the id
   *
   * @tags CRUD/Rules
   * @name FindRulesByIds
   * @request GET:/v1/tenant/{tenantId}/rule-by-ids
   * @secure
   */
  findRulesByIds = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the rules is missing
       * @default false
       */
      strict?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapRuleIdRuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRulesByIds */
  findRulesByIdsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the rules is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rule-by-ids`, query);

  /**
   * @description attempts to find rule specified by the id
   *
   * @tags CRUD/Rules
   * @name FindRulesByIdsPut
   * @request PUT:/v1/tenant/{tenantId}/rule-by-ids
   * @secure
   */
  findRulesByIdsPut = (tenantId: string, data: QueryRulesRequest, params: RequestParams = {}) =>
    this.request<
      MapRuleIdRuleView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rule-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRulesByIdsPut */
  findRulesByIdsPutPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/rule-by-ids`);

  /**
   * @description migrate all rules to explicit, replaces object aliases with explicit data objects if feasible
   *
   * @tags CRUD/Rules
   * @name MigrateAllRulesToExplicitRule
   * @request PUT:/v1/tenant/{tenantId}/migrate-all-to-explicit
   * @secure
   */
  migrateAllRulesToExplicitRule = (
    tenantId: string,
    query?: {
      dry?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      Draft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/migrate-all-to-explicit`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for migrateAllRulesToExplicitRule */
  migrateAllRulesToExplicitRulePathGetter = (
    tenantId: string,
    query?: {
      dry?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/migrate-all-to-explicit`, query);

  /**
   * @description migrate rule to explicit, replaces object aliases with explicit data objects if feasible
   *
   * @tags CRUD/Rules
   * @name MigrateRuleToExplicitRule
   * @request PUT:/v1/tenant/{tenantId}/migrate-to-explicit
   * @secure
   */
  migrateRuleToExplicitRule = (
    tenantId: string,
    data: MigrateToExplicitRequest,
    query?: {
      dry?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      Draft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/migrate-to-explicit`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for migrateRuleToExplicitRule */
  migrateRuleToExplicitRulePathGetter = (
    tenantId: string,
    query?: {
      dry?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/migrate-to-explicit`, query);

  /**
   * @description attempts to find rule draft specified by the id
   *
   * @tags CRUD/Draft
   * @name FindRuleDraft
   * @request GET:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  findRuleDraft = (tenantId: string, draftId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRuleDraft */
  findRuleDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description update rule draft for specified revision ONLY
   *
   * @tags CRUD/Draft
   * @name UpdateRuleDraft
   * @request PUT:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  updateRuleDraft = (tenantId: string, draftId: string, data: DraftUpdateRequest, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateRuleDraft */
  updateRuleDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description replace rule draft specified by the id
   *
   * @tags CRUD/Draft
   * @name ReplaceRuleDraft
   * @request POST:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  replaceRuleDraft = (tenantId: string, draftId: string, data: DraftUpdateRequest, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceRuleDraft */
  replaceRuleDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description deletes rule draft specified by the id
   *
   * @tags CRUD/Draft
   * @name DeleteRuleDraft
   * @request DELETE:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  deleteRuleDraft = (tenantId: string, draftId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteRuleDraft */
  deleteRuleDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description creates rule draft
   *
   * @tags CRUD/Draft
   * @name CreateRuleDraft
   * @request POST:/v1/tenant/{tenantId}/draft
   * @secure
   */
  createRuleDraft = (
    tenantId: string,
    data: DraftCreateRequest,
    query?: {
      /**
       * describes version of rule builder - flag has no impact on execution
       * @default "Default"
       * @example "ExplicitV1"
       */
      ruleBuilderVersion?: RuleBuilderVersion;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createRuleDraft */
  createRuleDraftPathGetter = (
    tenantId: string,
    query?: {
      /**
       * describes version of rule builder - flag has no impact on execution
       * @default "Default"
       * @example "ExplicitV1"
       */
      ruleBuilderVersion?: RuleBuilderVersion;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/draft`, query);

  /**
   * @description attempts to find rule drafts specified by the ids
   *
   * @tags CRUD/Draft
   * @name FindRuleDraftsByIds
   * @request GET:/v1/tenant/{tenantId}/draft-by-ids
   * @secure
   */
  findRuleDraftsByIds = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the rules is missing
       * @default false
       */
      strict?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDraftIdWrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRuleDraftsByIds */
  findRuleDraftsByIdsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the rules is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/draft-by-ids`, query);

  /**
   * @description attempts to find rule drafts specified by the ids
   *
   * @tags CRUD/Draft
   * @name FindRuleDraftsByIdsPut
   * @request PUT:/v1/tenant/{tenantId}/draft-by-ids
   * @secure
   */
  findRuleDraftsByIdsPut = (tenantId: string, data: QueryDraftsRequest, params: RequestParams = {}) =>
    this.request<
      MapDraftIdWrappedDraft,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRuleDraftsByIdsPut */
  findRuleDraftsByIdsPutPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/draft-by-ids`);

  /**
   * @description query with provided filters - returns MATCHING by id rules and drafts
   *
   * @tags Queries
   * @name QueryRulesAndDrafts
   * @request GET:/v1/tenant/{tenantId}/rules-and-drafts
   * @secure
   */
  queryRulesAndDrafts = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * csv of $field(:$order)? <br>available fields: createdAt,updatedAt,ruleType, available orders: asc,desc
       * @minLength 1
       * @default "createdAt:desc"
       * @example "ruleType:asc,createdAt:desc"
       */
      orderBy?: string;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Is CS Admin" */
      name?: string;
      /** @example "NonOwnershipRule" */
      type?: RuleType;
      /**
       * describes subset of rule builder versions - flag has no impact on execution
       * @minItems 1
       * @default ["Default"]
       * @example ["Default","ExplicitV1"]
       */
      ruleBuilderVersion?: RuleBuilderVersion[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDraftAndRule,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/rules-and-drafts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryRulesAndDrafts */
  queryRulesAndDraftsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * csv of $field(:$order)? <br>available fields: createdAt,updatedAt,ruleType, available orders: asc,desc
       * @minLength 1
       * @default "createdAt:desc"
       * @example "ruleType:asc,createdAt:desc"
       */
      orderBy?: string;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Is CS Admin" */
      name?: string;
      /** @example "NonOwnershipRule" */
      type?: RuleType;
      /**
       * describes subset of rule builder versions - flag has no impact on execution
       * @minItems 1
       * @default ["Default"]
       * @example ["Default","ExplicitV1"]
       */
      ruleBuilderVersion?: RuleBuilderVersion[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/rules-and-drafts`, query);

  /**
   * @description returns raw request from rule that can be used to create / update rule
   *
   * @tags Draft/Compat
   * @name RuleRawRequest
   * @request GET:/v1/tenant/{tenantId}/raw-request-for-rule/{ruleId}
   * @secure
   */
  ruleRawRequest = (tenantId: string, ruleId: string, params: RequestParams = {}) =>
    this.request<
      CreateRuleDto,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/raw-request-for-rule/${ruleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for ruleRawRequest */
  ruleRawRequestPathGetter = (tenantId: string, ruleId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/raw-request-for-rule/${ruleId}`);

  /**
   * @description returns raw requests from rule that can be used to create / update rule
   *
   * @tags Draft/Compat
   * @name BatchForRuleRawRequests
   * @request GET:/v1/tenant/{tenantId}/raw-request-for-rule
   * @secure
   */
  batchForRuleRawRequests = (
    tenantId: string,
    query?: {
      ids?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapRuleIdCreateRuleDto,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/raw-request-for-rule`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for batchForRuleRawRequests */
  batchForRuleRawRequestsPathGetter = (
    tenantId: string,
    query?: {
      ids?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/raw-request-for-rule`, query);

  /**
   * @description list available fields for default objects
   *
   * @tags Fields
   * @name ListFields
   * @request GET:/v1/tenant/{tenantId}/fields
   * @secure
   */
  listFields = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataSourceArrayDataObjectMetadataView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/fields`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listFields */
  listFieldsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/fields`, query);

  /**
   * @description list available operators
   *
   * @tags Fields
   * @name ListOperatorsOld
   * @request GET:/v1/tenant/{tenantId}/fields/operators
   * @secure
   */
  listOperatorsOld = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataSourceArrayDataFieldTypeMetadata,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/fields/operators`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listOperatorsOld */
  listOperatorsOldPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/fields/operators`, query);

  /**
   * @description lists available fields metadata for salesforce l2a matching
   *
   * @tags Fields
   * @name ListFieldsForSalesforceL2A
   * @request GET:/v1/tenant/{tenantId}/fields-for-salesforce-l2a
   * @secure
   */
  listFieldsForSalesforceL2A = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      MetadataForSalesforceL2A,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/fields-for-salesforce-l2a`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listFieldsForSalesforceL2A */
  listFieldsForSalesforceL2APathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/fields-for-salesforce-l2a`);

  /**
   * @description list available operators for salesforce l2a
   *
   * @tags Fields
   * @name ListOperatorsForSalesforceL2A
   * @request GET:/v1/tenant/{tenantId}/fields/operators-for-salesforce-l2a
   * @secure
   */
  listOperatorsForSalesforceL2A = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      MapDataSourceArrayDataFieldTypeMetadata,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/fields/operators-for-salesforce-l2a`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listOperatorsForSalesforceL2A */
  listOperatorsForSalesforceL2APathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/fields/operators-for-salesforce-l2a`);

  /**
   * No description
   *
   * @tags Fields
   * @name ListAvailableFieldsForSalesforceObjectMatchingFiltering
   * @request GET:/v1/tenant/{tenantId}/salesforce-matching/fields-for-filters
   * @secure
   */
  listAvailableFieldsForSalesforceObjectMatchingFiltering = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["Account","Case"]
       */
      objects: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayDataObjectMetadataView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/salesforce-matching/fields-for-filters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAvailableFieldsForSalesforceObjectMatchingFiltering */
  listAvailableFieldsForSalesforceObjectMatchingFilteringPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["Account","Case"]
       */
      objects: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/salesforce-matching/fields-for-filters`, query);

  /**
   * No description
   *
   * @tags Fields
   * @name ListAvailableFieldsForSalesforceObjectMatchingTiebreaks
   * @request GET:/v1/tenant/{tenantId}/salesforce-matching/fields-for-tiebreaks
   * @secure
   */
  listAvailableFieldsForSalesforceObjectMatchingTiebreaks = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["Account","Case"]
       */
      objects: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayFieldsForTiebreaks,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/salesforce-matching/fields-for-tiebreaks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAvailableFieldsForSalesforceObjectMatchingTiebreaks */
  listAvailableFieldsForSalesforceObjectMatchingTiebreaksPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["Account","Case"]
       */
      objects: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/salesforce-matching/fields-for-tiebreaks`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseRes[],
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);

  /**
   * @description attempts to find salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name FindSalesforceL2AConfigById
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a/{configId}
   * @secure
   */
  findSalesforceL2AConfigById = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceL2AConfigById */
  findSalesforceL2AConfigByIdPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name ReplaceSalesforceL2AConfigById
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a/{configId}
   * @secure
   */
  replaceSalesforceL2AConfigById = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2AccountConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceL2AConfigById */
  replaceSalesforceL2AConfigByIdPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`);

  /**
   * @description creates salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name CreateSalesforceL2AConfigById
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a/{configId}
   * @secure
   */
  createSalesforceL2AConfigById = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2AccountConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceL2AConfigById */
  createSalesforceL2AConfigByIdPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`);

  /**
   * @description deletes salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name DeletesSalesforceL2AConfigById
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a/{configId}
   * @secure
   */
  deletesSalesforceL2AConfigById = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceL2AConfigById */
  deletesSalesforceL2AConfigByIdPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a/${configId}`);

  /**
   * @description attempts to find default salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name FindSalesforceL2AConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a
   * @secure
   */
  findSalesforceL2AConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceL2AConfig */
  findSalesforceL2AConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`, query);

  /**
   * @description replaces default salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name ReplaceSalesforceL2AConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a
   * @secure
   */
  replaceSalesforceL2AConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2AccountConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceL2AConfig */
  replaceSalesforceL2AConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`);

  /**
   * @description creates default salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name CreateSalesforceL2AConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a
   * @secure
   */
  createSalesforceL2AConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2AccountConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceL2AConfig */
  createSalesforceL2AConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`);

  /**
   * @description deletes default salesforce l2a config for workspace
   *
   * @tags CRUD/Matching/Account
   * @name DeletesSalesforceL2AConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2a
   * @secure
   */
  deletesSalesforceL2AConfig = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceLead2AccountMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceL2AConfig */
  deletesSalesforceL2AConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2a`);

  /**
   * @description attempts to materialize requested data and ownerships
   *
   * @tags Materialization
   * @name PreviewMaterializeRequestedData
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/materialize
   * @secure
   */
  previewMaterializeRequestedData = (
    tenantId: string,
    workspaceId: string,
    data: PreviewMaterializationRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MaterializationResponse,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/materialize`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for previewMaterializeRequestedData */
  previewMaterializeRequestedDataPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/materialize`);

  /**
   * @description attempts to evaluate rule specified by id with the provided input
   *
   * @tags Evaluation
   * @name PreviewRuleEvaluation
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/execute
   * @secure
   */
  previewRuleEvaluation = (
    tenantId: string,
    workspaceId: string,
    data: PreviewRuleExecutionRequest,
    query?: {
      /**
       * whether response should contain execution log
       * @default true
       * @example true
       */
      includeExecutionLog?: boolean;
      /**
       * whether response should contain gathered data used for rule materialization
       * @default false
       * @example false
       */
      includeGatheredData?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      RuleExecutionResult,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/execute`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for previewRuleEvaluation */
  previewRuleEvaluationPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * whether response should contain execution log
       * @default true
       * @example true
       */
      includeExecutionLog?: boolean;
      /**
       * whether response should contain gathered data used for rule materialization
       * @default false
       * @example false
       */
      includeGatheredData?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/execute`, query);

  /**
   * @description attempts to evaluate rules
   *
   * @tags Evaluation
   * @name BatchPreviewRuleEvaluation
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/batch-execute
   * @secure
   */
  batchPreviewRuleEvaluation = (
    tenantId: string,
    workspaceId: string,
    data: PreviewBatchRuleExecutionRequest,
    query?: {
      /**
       * whether response should contain execution log
       * @default true
       * @example true
       */
      includeExecutionLog?: boolean;
      /**
       * whether response should contain gathered data used for rule materialization
       * @default false
       * @example false
       */
      includeGatheredData?: boolean;
      /**
       * whether batch execution should be short circuted on any error - if set to false - any errors will be included under `errors` property in results
       * @default true
       * @example true
       */
      shortCircuitExecutionOnError?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      BatchRuleExecutionResult,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/batch-execute`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for batchPreviewRuleEvaluation */
  batchPreviewRuleEvaluationPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * whether response should contain execution log
       * @default true
       * @example true
       */
      includeExecutionLog?: boolean;
      /**
       * whether response should contain gathered data used for rule materialization
       * @default false
       * @example false
       */
      includeGatheredData?: boolean;
      /**
       * whether batch execution should be short circuted on any error - if set to false - any errors will be included under `errors` property in results
       * @default true
       * @example true
       */
      shortCircuitExecutionOnError?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/batch-execute`, query);

  /**
   * @description attempts to find salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name FindSalesforceLeadToDuplicateLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl/{configId}
   * @secure
   */
  findSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceLeadToDuplicateLeadConfig */
  findSalesforceLeadToDuplicateLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name ReplaceSalesforceLeadToDuplicateLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl/{configId}
   * @secure
   */
  replaceSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceLeadToDuplicateLeadConfig */
  replaceSalesforceLeadToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`);

  /**
   * @description creates salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name CreateSalesforceLeadToDuplicateLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl/{configId}
   * @secure
   */
  createSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceLeadToDuplicateLeadConfig */
  createSalesforceLeadToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`);

  /**
   * @description deletes salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name DeletesSalesforceLeadToDuplicateLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl/{configId}
   * @secure
   */
  deletesSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceLeadToDuplicateLeadConfig */
  deletesSalesforceLeadToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl/${configId}`);

  /**
   * @description attempts to find default salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name FindDefaultSalesforceLeadToDuplicateLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl
   * @secure
   */
  findDefaultSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceLeadToDuplicateLeadConfig */
  findDefaultSalesforceLeadToDuplicateLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`, query);

  /**
   * @description replaces default salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name ReplaceDefaultSalesforceLeadToDuplicateLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl
   * @secure
   */
  replaceDefaultSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceLeadToDuplicateLeadConfig */
  replaceDefaultSalesforceLeadToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`);

  /**
   * @description creates default default salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name CreateDefaultDefaultSalesforceLeadToDuplicateLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl
   * @secure
   */
  createDefaultDefaultSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceLeadToDuplicateLeadConfig */
  createDefaultDefaultSalesforceLeadToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`);

  /**
   * @description deletes default salesforce lead to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name DeletesDefaultSalesforceLeadToDuplicateLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dl
   * @secure
   */
  deletesDefaultSalesforceLeadToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceLeadToDuplicateLeadConfig */
  deletesDefaultSalesforceLeadToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dl`);

  /**
   * @description attempts to find salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name FindSalesforceContactToDuplicateLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl/{configId}
   * @secure
   */
  findSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceContactToDuplicateLeadConfig */
  findSalesforceContactToDuplicateLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name ReplaceSalesforceContactToDuplicateLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl/{configId}
   * @secure
   */
  replaceSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceContactToDuplicateLeadConfig */
  replaceSalesforceContactToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`);

  /**
   * @description creates salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name CreateSalesforceContactToDuplicateLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl/{configId}
   * @secure
   */
  createSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceContactToDuplicateLeadConfig */
  createSalesforceContactToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`);

  /**
   * @description deletes salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name DeletesSalesforceContactToDuplicateLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl/{configId}
   * @secure
   */
  deletesSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceContactToDuplicateLeadConfig */
  deletesSalesforceContactToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl/${configId}`);

  /**
   * @description attempts to find default salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name FindDefaultSalesforceContactToDuplicateLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl
   * @secure
   */
  findDefaultSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceContactToDuplicateLeadConfig */
  findDefaultSalesforceContactToDuplicateLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`, query);

  /**
   * @description replaces default salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name ReplaceDefaultSalesforceContactToDuplicateLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl
   * @secure
   */
  replaceDefaultSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceContactToDuplicateLeadConfig */
  replaceDefaultSalesforceContactToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`);

  /**
   * @description creates default default salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name CreateDefaultDefaultSalesforceContactToDuplicateLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl
   * @secure
   */
  createDefaultDefaultSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2DuplicateLeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceContactToDuplicateLeadConfig */
  createDefaultDefaultSalesforceContactToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`);

  /**
   * @description deletes default salesforce contact to duplicate lead config for workspace
   *
   * @tags CRUD/Matching/DuplicateLead
   * @name DeletesDefaultSalesforceContactToDuplicateLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dl
   * @secure
   */
  deletesDefaultSalesforceContactToDuplicateLeadConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceContactToDuplicateLeadConfig */
  deletesDefaultSalesforceContactToDuplicateLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dl`);

  /**
   * @description attempts to find salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name FindSalesforceProspectToLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l/{configId}
   * @secure
   */
  findSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceProspectToLeadConfig */
  findSalesforceProspectToLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name ReplaceSalesforceProspectToLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l/{configId}
   * @secure
   */
  replaceSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceProspect2LeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceProspectToLeadConfig */
  replaceSalesforceProspectToLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`);

  /**
   * @description creates salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name CreateSalesforceProspectToLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l/{configId}
   * @secure
   */
  createSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceProspect2LeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceProspectToLeadConfig */
  createSalesforceProspectToLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`);

  /**
   * @description deletes salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name DeletesSalesforceProspectToLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l/{configId}
   * @secure
   */
  deletesSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceProspectToLeadConfig */
  deletesSalesforceProspectToLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/${configId}`);

  /**
   * @description attempts to find default salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name FindDefaultSalesforceProspectToLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l
   * @secure
   */
  findDefaultSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceProspectToLeadConfig */
  findDefaultSalesforceProspectToLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`, query);

  /**
   * @description replaces default salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name ReplaceDefaultSalesforceProspectToLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l
   * @secure
   */
  replaceDefaultSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceProspect2LeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceProspectToLeadConfig */
  replaceDefaultSalesforceProspectToLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`);

  /**
   * @description creates default default salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name CreateDefaultDefaultSalesforceProspectToLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l
   * @secure
   */
  createDefaultDefaultSalesforceProspectToLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceProspect2LeadConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceProspectToLeadConfig */
  createDefaultDefaultSalesforceProspectToLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`);

  /**
   * @description deletes default salesforce prospect to lead config for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name DeletesDefaultSalesforceProspectToLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l
   * @secure
   */
  deletesDefaultSalesforceProspectToLeadConfig = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceProspectToLeadConfig */
  deletesDefaultSalesforceProspectToLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l`);

  /**
   * @description lists all salesforce prospect to lead configs for workspace
   *
   * @tags CRUD/Matching/MatchedLead
   * @name ListAllSalesforceProspectToLeadConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l/list/all
   * @secure
   */
  listAllSalesforceProspectToLeadConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceProspectToLeadConfigs */
  listAllSalesforceProspectToLeadConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/list/all`,
      query,
    );

  /**
   * @description retrieves prospect to lead configs specified by ids
   *
   * @tags CRUD/Matching/MatchedLead
   * @name GetSalesforceProspectToLeadConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2l/list/by-ids
   * @secure
   */
  getSalesforceProspectToLeadConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceProspectToLeadConfigsByIds */
  getSalesforceProspectToLeadConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2l/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name FindSalesforceContactToDuplicateContactConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc/{configId}
   * @secure
   */
  findSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceContactToDuplicateContactConfig */
  findSalesforceContactToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name ReplaceSalesforceContactToDuplicateContactConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc/{configId}
   * @secure
   */
  replaceSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceContactToDuplicateContactConfig */
  replaceSalesforceContactToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`);

  /**
   * @description creates salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name CreateSalesforceContactToDuplicateContactConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc/{configId}
   * @secure
   */
  createSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceContactToDuplicateContactConfig */
  createSalesforceContactToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`);

  /**
   * @description deletes salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name DeletesSalesforceContactToDuplicateContactConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc/{configId}
   * @secure
   */
  deletesSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceContactToDuplicateContactConfig */
  deletesSalesforceContactToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/${configId}`);

  /**
   * @description attempts to find default salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name FindDefaultSalesforceContactToDuplicateContactConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc
   * @secure
   */
  findDefaultSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceContactToDuplicateContactConfig */
  findDefaultSalesforceContactToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`, query);

  /**
   * @description replaces default salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name ReplaceDefaultSalesforceContactToDuplicateContactConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc
   * @secure
   */
  replaceDefaultSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceContactToDuplicateContactConfig */
  replaceDefaultSalesforceContactToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`);

  /**
   * @description creates default salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name CreateDefaultDefaultSalesforceContactToDuplicateContactConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc
   * @secure
   */
  createDefaultDefaultSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceContactToDuplicateContactConfig */
  createDefaultDefaultSalesforceContactToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`);

  /**
   * @description deletes default salesforce contact to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name DeletesDefaultSalesforceContactToDuplicateContactConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc
   * @secure
   */
  deletesDefaultSalesforceContactToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceContactToDuplicateContactConfig */
  deletesDefaultSalesforceContactToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc`);

  /**
   * @description lists all salesforce contact to duplicate contact configs for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name ListAllSalesforceContactToDuplicateContactConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc/list/all
   * @secure
   */
  listAllSalesforceContactToDuplicateContactConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceContactToDuplicateContactConfigs */
  listAllSalesforceContactToDuplicateContactConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/list/all`,
      query,
    );

  /**
   * @description retrieves contact to duplicate contact configs specified by ids
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name GetSalesforceContactToDuplicateContactConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2dc/list/by-ids
   * @secure
   */
  getSalesforceContactToDuplicateContactConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceContactToDuplicateContactConfigsByIds */
  getSalesforceContactToDuplicateContactConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2dc/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name FindSalesforceLeadToDuplicateContactConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc/{configId}
   * @secure
   */
  findSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceLeadToDuplicateContactConfig */
  findSalesforceLeadToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name ReplaceSalesforceLeadToDuplicateContactConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc/{configId}
   * @secure
   */
  replaceSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceLeadToDuplicateContactConfig */
  replaceSalesforceLeadToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`);

  /**
   * @description creates salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name CreateSalesforceLeadToDuplicateContactConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc/{configId}
   * @secure
   */
  createSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceLeadToDuplicateContactConfig */
  createSalesforceLeadToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`);

  /**
   * @description deletes salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name DeletesSalesforceLeadToDuplicateContactConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc/{configId}
   * @secure
   */
  deletesSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceLeadToDuplicateContactConfig */
  deletesSalesforceLeadToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/${configId}`);

  /**
   * @description attempts to find default salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name FindDefaultSalesforceLeadToDuplicateContactConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc
   * @secure
   */
  findDefaultSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceLeadToDuplicateContactConfig */
  findDefaultSalesforceLeadToDuplicateContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`, query);

  /**
   * @description replaces default salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name ReplaceDefaultSalesforceLeadToDuplicateContactConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc
   * @secure
   */
  replaceDefaultSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceLeadToDuplicateContactConfig */
  replaceDefaultSalesforceLeadToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`);

  /**
   * @description creates default default salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name CreateDefaultDefaultSalesforceLeadToDuplicateContactConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc
   * @secure
   */
  createDefaultDefaultSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2DuplicateContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceLeadToDuplicateContactConfig */
  createDefaultDefaultSalesforceLeadToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`);

  /**
   * @description deletes default salesforce lead to duplicate contact config for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name DeletesDefaultSalesforceLeadToDuplicateContactConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc
   * @secure
   */
  deletesDefaultSalesforceLeadToDuplicateContactConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceLeadToDuplicateContactConfig */
  deletesDefaultSalesforceLeadToDuplicateContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc`);

  /**
   * @description lists all salesforce lead to duplicate contact configs for workspace
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name ListAllSalesforceLeadToDuplicateContactConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc/list/all
   * @secure
   */
  listAllSalesforceLeadToDuplicateContactConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceLeadToDuplicateContactConfigs */
  listAllSalesforceLeadToDuplicateContactConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/list/all`,
      query,
    );

  /**
   * @description retrieves lead to duplicate contact configs specified by ids
   *
   * @tags CRUD/Matching/DuplicateContact
   * @name GetSalesforceLeadToDuplicateContactConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2dc/list/by-ids
   * @secure
   */
  getSalesforceLeadToDuplicateContactConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceLeadToDuplicateContactConfigsByIds */
  getSalesforceLeadToDuplicateContactConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2dc/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name FindSalesforceProspectToMatchedContactConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c/{configId}
   * @secure
   */
  findSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceProspectToMatchedContactConfig */
  findSalesforceProspectToMatchedContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name ReplaceSalesforceProspectToMatchedContactConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c/{configId}
   * @secure
   */
  replaceSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceProspect2ContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceProspectToMatchedContactConfig */
  replaceSalesforceProspectToMatchedContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`);

  /**
   * @description creates salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name CreateSalesforceProspectToMatchedContactConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c/{configId}
   * @secure
   */
  createSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceProspect2ContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceProspectToMatchedContactConfig */
  createSalesforceProspectToMatchedContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`);

  /**
   * @description deletes salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name DeletesSalesforceProspectToMatchedContactConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c/{configId}
   * @secure
   */
  deletesSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceProspectToMatchedContactConfig */
  deletesSalesforceProspectToMatchedContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/${configId}`);

  /**
   * @description attempts to find default salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name FindDefaultSalesforceProspectToMatchedContactConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c
   * @secure
   */
  findDefaultSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceProspectToMatchedContactConfig */
  findDefaultSalesforceProspectToMatchedContactConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`, query);

  /**
   * @description replaces default salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name ReplaceDefaultSalesforceProspectToMatchedContactConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c
   * @secure
   */
  replaceDefaultSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceProspect2ContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceProspectToMatchedContactConfig */
  replaceDefaultSalesforceProspectToMatchedContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`);

  /**
   * @description creates default default salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name CreateDefaultDefaultSalesforceProspectToMatchedContactConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c
   * @secure
   */
  createDefaultDefaultSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceProspect2ContactConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceProspectToMatchedContactConfig */
  createDefaultDefaultSalesforceProspectToMatchedContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`);

  /**
   * @description deletes default salesforce prospect to matched contact config for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name DeletesDefaultSalesforceProspectToMatchedContactConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c
   * @secure
   */
  deletesDefaultSalesforceProspectToMatchedContactConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceProspectToMatchedContactConfig */
  deletesDefaultSalesforceProspectToMatchedContactConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c`);

  /**
   * @description lists all salesforce prospect to matched contact configs for workspace
   *
   * @tags CRUD/Matching/MatchedContact
   * @name ListAllSalesforceProspectToMatchedContactConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c/list/all
   * @secure
   */
  listAllSalesforceProspectToMatchedContactConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceProspectToMatchedContactConfigs */
  listAllSalesforceProspectToMatchedContactConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/list/all`,
      query,
    );

  /**
   * @description retrieves prospect to matched contact configs specified by ids
   *
   * @tags CRUD/Matching/MatchedContact
   * @name GetSalesforceProspectToMatchedContactConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-p2c/list/by-ids
   * @secure
   */
  getSalesforceProspectToMatchedContactConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceContactMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceProspectToMatchedContactConfigsByIds */
  getSalesforceProspectToMatchedContactConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-p2c/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce child matching config for workspace
   *
   * @tags CRUD/Matching/Children
   * @name FindSalesforceChildMatchingConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-children/{relatedChildObjectRef}
   * @secure
   */
  findSalesforceChildMatchingConfig = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceChildMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceChildMatchingConfig */
  findSalesforceChildMatchingConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
    );

  /**
   * @description replaces salesforce child matching config for workspace
   *
   * @tags CRUD/Matching/Children
   * @name ReplaceSalesforceChildMatchingConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-children/{relatedChildObjectRef}
   * @secure
   */
  replaceSalesforceChildMatchingConfig = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
    data: SalesforceChildMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceChildMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceChildMatchingConfig */
  replaceSalesforceChildMatchingConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
    );

  /**
   * @description creates salesforce child matching config for workspace
   *
   * @tags CRUD/Matching/Children
   * @name CreateSalesforceChildMatchingConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-children/{relatedChildObjectRef}
   * @secure
   */
  createSalesforceChildMatchingConfig = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
    data: SalesforceChildMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceChildMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceChildMatchingConfig */
  createSalesforceChildMatchingConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
    );

  /**
   * @description deletes salesforce child matching config for workspace
   *
   * @tags CRUD/Matching/Children
   * @name DeletesSalesforceChildMatchingConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-children/{relatedChildObjectRef}
   * @secure
   */
  deletesSalesforceChildMatchingConfig = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceChildMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceChildMatchingConfig */
  deletesSalesforceChildMatchingConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    relatedChildObjectRef: string,
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children/${relatedChildObjectRef}`,
    );

  /**
   * @description attempts to list salesforce child matching config for workspace
   *
   * @tags CRUD/Matching/Children
   * @name ListSalesforceChildMatchingConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-children
   * @secure
   */
  listSalesforceChildMatchingConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * ngram query for both names and ref
       * @example "LatestOpp"
       */
      label?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceChildMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSalesforceChildMatchingConfigs */
  listSalesforceChildMatchingConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /**
       * ngram query for both names and ref
       * @example "LatestOpp"
       */
      label?: string;
    },
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-children`, query);

  /**
   * @description attempts to find salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name FindSalesforceLeadToCaseConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case/{configId}
   * @secure
   */
  findSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceLeadToCaseConfig */
  findSalesforceLeadToCaseConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name ReplaceSalesforceLeadToCaseConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case/{configId}
   * @secure
   */
  replaceSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceLeadToCaseConfig */
  replaceSalesforceLeadToCaseConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
    );

  /**
   * @description creates salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name CreateSalesforceLeadToCaseConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case/{configId}
   * @secure
   */
  createSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceLeadToCaseConfig */
  createSalesforceLeadToCaseConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
    );

  /**
   * @description deletes salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name DeletesSalesforceLeadToCaseConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case/{configId}
   * @secure
   */
  deletesSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceLeadToCaseConfig */
  deletesSalesforceLeadToCaseConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/${configId}`,
    );

  /**
   * @description attempts to find default salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name FindDefaultSalesforceLeadToCaseConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case
   * @secure
   */
  findDefaultSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceLeadToCaseConfig */
  findDefaultSalesforceLeadToCaseConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`, query);

  /**
   * @description replaces default salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name ReplaceDefaultSalesforceLeadToCaseConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case
   * @secure
   */
  replaceDefaultSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceLeadToCaseConfig */
  replaceDefaultSalesforceLeadToCaseConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`);

  /**
   * @description creates default default salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name CreateDefaultDefaultSalesforceLeadToCaseConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case
   * @secure
   */
  createDefaultDefaultSalesforceLeadToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceLeadToCaseConfig */
  createDefaultDefaultSalesforceLeadToCaseConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`);

  /**
   * @description deletes default salesforce lead to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name DeletesDefaultSalesforceLeadToCaseConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case
   * @secure
   */
  deletesDefaultSalesforceLeadToCaseConfig = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceLeadToCaseConfig */
  deletesDefaultSalesforceLeadToCaseConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case`);

  /**
   * @description lists all salesforce lead to case configs for workspace
   *
   * @tags CRUD/Matching/Case
   * @name ListAllSalesforceLeadToCaseConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case/list/all
   * @secure
   */
  listAllSalesforceLeadToCaseConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceLeadToCaseConfigs */
  listAllSalesforceLeadToCaseConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/list/all`,
      query,
    );

  /**
   * @description retrieves lead to case configs specified by ids
   *
   * @tags CRUD/Matching/Case
   * @name GetSalesforceLeadToCaseConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2case/list/by-ids
   * @secure
   */
  getSalesforceLeadToCaseConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceLeadToCaseConfigsByIds */
  getSalesforceLeadToCaseConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2case/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name FindSalesforceContactToCaseConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case/{configId}
   * @secure
   */
  findSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceContactToCaseConfig */
  findSalesforceContactToCaseConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name ReplaceSalesforceContactToCaseConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case/{configId}
   * @secure
   */
  replaceSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceContactToCaseConfig */
  replaceSalesforceContactToCaseConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
    );

  /**
   * @description creates salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name CreateSalesforceContactToCaseConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case/{configId}
   * @secure
   */
  createSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceContactToCaseConfig */
  createSalesforceContactToCaseConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
    );

  /**
   * @description deletes salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name DeletesSalesforceContactToCaseConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case/{configId}
   * @secure
   */
  deletesSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceContactToCaseConfig */
  deletesSalesforceContactToCaseConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/${configId}`,
    );

  /**
   * @description attempts to find default salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name FindDefaultSalesforceContactToCaseConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case
   * @secure
   */
  findDefaultSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceContactToCaseConfig */
  findDefaultSalesforceContactToCaseConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`, query);

  /**
   * @description replaces default salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name ReplaceDefaultSalesforceContactToCaseConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case
   * @secure
   */
  replaceDefaultSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceContactToCaseConfig */
  replaceDefaultSalesforceContactToCaseConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`);

  /**
   * @description creates default default salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name CreateDefaultDefaultSalesforceContactToCaseConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case
   * @secure
   */
  createDefaultDefaultSalesforceContactToCaseConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2CaseMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceContactToCaseConfig */
  createDefaultDefaultSalesforceContactToCaseConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`);

  /**
   * @description deletes default salesforce contact to case config for workspace
   *
   * @tags CRUD/Matching/Case
   * @name DeletesDefaultSalesforceContactToCaseConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case
   * @secure
   */
  deletesDefaultSalesforceContactToCaseConfig = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      SalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceContactToCaseConfig */
  deletesDefaultSalesforceContactToCaseConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case`);

  /**
   * @description lists all salesforce contact to case configs for workspace
   *
   * @tags CRUD/Matching/Case
   * @name ListAllSalesforceContactToCaseConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case/list/all
   * @secure
   */
  listAllSalesforceContactToCaseConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceContactToCaseConfigs */
  listAllSalesforceContactToCaseConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/list/all`,
      query,
    );

  /**
   * @description retrieves contact to case configs specified by ids
   *
   * @tags CRUD/Matching/Case
   * @name GetSalesforceContactToCaseConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2case/list/by-ids
   * @secure
   */
  getSalesforceContactToCaseConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceCaseMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceContactToCaseConfigsByIds */
  getSalesforceContactToCaseConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2case/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name FindSalesforceLeadToOpportunityConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp/{configId}
   * @secure
   */
  findSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceLeadToOpportunityConfig */
  findSalesforceLeadToOpportunityConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name ReplaceSalesforceLeadToOpportunityConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp/{configId}
   * @secure
   */
  replaceSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceLeadToOpportunityConfig */
  replaceSalesforceLeadToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`);

  /**
   * @description creates salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name CreateSalesforceLeadToOpportunityConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp/{configId}
   * @secure
   */
  createSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceLeadToOpportunityConfig */
  createSalesforceLeadToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`);

  /**
   * @description deletes salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name DeletesSalesforceLeadToOpportunityConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp/{configId}
   * @secure
   */
  deletesSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceLeadToOpportunityConfig */
  deletesSalesforceLeadToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/${configId}`);

  /**
   * @description attempts to find default salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name FindDefaultSalesforceLeadToOpportunityConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp
   * @secure
   */
  findDefaultSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceLeadToOpportunityConfig */
  findDefaultSalesforceLeadToOpportunityConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`, query);

  /**
   * @description replaces default salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name ReplaceDefaultSalesforceLeadToOpportunityConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp
   * @secure
   */
  replaceDefaultSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceLeadToOpportunityConfig */
  replaceDefaultSalesforceLeadToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`);

  /**
   * @description creates default default salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name CreateDefaultDefaultSalesforceLeadToOpportunityConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp
   * @secure
   */
  createDefaultDefaultSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceLeadToOpportunityConfig */
  createDefaultDefaultSalesforceLeadToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`);

  /**
   * @description deletes default salesforce lead to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name DeletesDefaultSalesforceLeadToOpportunityConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp
   * @secure
   */
  deletesDefaultSalesforceLeadToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceLeadToOpportunityConfig */
  deletesDefaultSalesforceLeadToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp`);

  /**
   * @description lists all salesforce lead to opportunity configs for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name ListAllSalesforceLeadToOpportunityConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp/list/all
   * @secure
   */
  listAllSalesforceLeadToOpportunityConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceLeadToOpportunityConfigs */
  listAllSalesforceLeadToOpportunityConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/list/all`,
      query,
    );

  /**
   * @description retrieves lead to opportunity configs specified by ids
   *
   * @tags CRUD/Matching/Opportunity
   * @name GetSalesforceLeadToOpportunityConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2opp/list/by-ids
   * @secure
   */
  getSalesforceLeadToOpportunityConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceLeadToOpportunityConfigsByIds */
  getSalesforceLeadToOpportunityConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2opp/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name FindSalesforceContactToOpportunityConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp/{configId}
   * @secure
   */
  findSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceContactToOpportunityConfig */
  findSalesforceContactToOpportunityConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name ReplaceSalesforceContactToOpportunityConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp/{configId}
   * @secure
   */
  replaceSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceContactToOpportunityConfig */
  replaceSalesforceContactToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`);

  /**
   * @description creates salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name CreateSalesforceContactToOpportunityConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp/{configId}
   * @secure
   */
  createSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceContact2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceContactToOpportunityConfig */
  createSalesforceContactToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`);

  /**
   * @description deletes salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name DeletesSalesforceContactToOpportunityConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp/{configId}
   * @secure
   */
  deletesSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceContactToOpportunityConfig */
  deletesSalesforceContactToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/${configId}`);

  /**
   * @description attempts to find default salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name FindDefaultSalesforceContactToOpportunityConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp
   * @secure
   */
  findDefaultSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceContactToOpportunityConfig */
  findDefaultSalesforceContactToOpportunityConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`, query);

  /**
   * @description replaces default salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name ReplaceDefaultSalesforceContactToOpportunityConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp
   * @secure
   */
  replaceDefaultSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceContactToOpportunityConfig */
  replaceDefaultSalesforceContactToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`);

  /**
   * @description creates default default salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name CreateDefaultDefaultSalesforceContactToOpportunityConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp
   * @secure
   */
  createDefaultDefaultSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceContact2OpportunityMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceContactToOpportunityConfig */
  createDefaultDefaultSalesforceContactToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`);

  /**
   * @description deletes default salesforce contact to opportunity config for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name DeletesDefaultSalesforceContactToOpportunityConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp
   * @secure
   */
  deletesDefaultSalesforceContactToOpportunityConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceContactToOpportunityConfig */
  deletesDefaultSalesforceContactToOpportunityConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp`);

  /**
   * @description lists all salesforce contact to opportunity configs for workspace
   *
   * @tags CRUD/Matching/Opportunity
   * @name ListAllSalesforceContactToOpportunityConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp/list/all
   * @secure
   */
  listAllSalesforceContactToOpportunityConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceContactToOpportunityConfigs */
  listAllSalesforceContactToOpportunityConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/list/all`,
      query,
    );

  /**
   * @description retrieves contact to opportunity configs specified by ids
   *
   * @tags CRUD/Matching/Opportunity
   * @name GetSalesforceContactToOpportunityConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-c2opp/list/by-ids
   * @secure
   */
  getSalesforceContactToOpportunityConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceOpportunityMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceContactToOpportunityConfigsByIds */
  getSalesforceContactToOpportunityConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-c2opp/list/by-ids`,
      query,
    );

  /**
   * @description attempts to find salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name FindSalesforceLeadToRelatedLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl/{configId}
   * @secure
   */
  findSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findSalesforceLeadToRelatedLeadConfig */
  findSalesforceLeadToRelatedLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`,
      query,
    );

  /**
   * @description replaces salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name ReplaceSalesforceLeadToRelatedLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl/{configId}
   * @secure
   */
  replaceSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2RelatedLeadMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceSalesforceLeadToRelatedLeadConfig */
  replaceSalesforceLeadToRelatedLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`);

  /**
   * @description creates salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name CreateSalesforceLeadToRelatedLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl/{configId}
   * @secure
   */
  createSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    data: SalesforceLead2RelatedLeadMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createSalesforceLeadToRelatedLeadConfig */
  createSalesforceLeadToRelatedLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`);

  /**
   * @description deletes salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name DeletesSalesforceLeadToRelatedLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl/{configId}
   * @secure
   */
  deletesSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesSalesforceLeadToRelatedLeadConfig */
  deletesSalesforceLeadToRelatedLeadConfigPathGetter = (tenantId: string, workspaceId: string, configId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/${configId}`);

  /**
   * @description attempts to find default salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name FindDefaultSalesforceLeadToRelatedLeadConfig
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl
   * @secure
   */
  findDefaultSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findDefaultSalesforceLeadToRelatedLeadConfig */
  findDefaultSalesforceLeadToRelatedLeadConfigPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * if set to `true` request will return default config matching config if none is defined for workspace
       * @default true
       */
      fallbackToDefault?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`, query);

  /**
   * @description replaces default salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name ReplaceDefaultSalesforceLeadToRelatedLeadConfig
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl
   * @secure
   */
  replaceDefaultSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2RelatedLeadMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceDefaultSalesforceLeadToRelatedLeadConfig */
  replaceDefaultSalesforceLeadToRelatedLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`);

  /**
   * @description creates default default salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name CreateDefaultDefaultSalesforceLeadToRelatedLeadConfig
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl
   * @secure
   */
  createDefaultDefaultSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    data: SalesforceLead2RelatedLeadMatchingConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createDefaultDefaultSalesforceLeadToRelatedLeadConfig */
  createDefaultDefaultSalesforceLeadToRelatedLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`);

  /**
   * @description deletes default salesforce lead to related lead config for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name DeletesDefaultSalesforceLeadToRelatedLeadConfig
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl
   * @secure
   */
  deletesDefaultSalesforceLeadToRelatedLeadConfig = (
    tenantId: string,
    workspaceId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      SalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesDefaultSalesforceLeadToRelatedLeadConfig */
  deletesDefaultSalesforceLeadToRelatedLeadConfigPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl`);

  /**
   * @description lists all salesforce lead to related lead configs for workspace
   *
   * @tags CRUD/Matching/RelatedLead
   * @name ListAllSalesforceLeadToRelatedLeadConfigs
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl/list/all
   * @secure
   */
  listAllSalesforceLeadToRelatedLeadConfigs = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultSalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/list/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllSalesforceLeadToRelatedLeadConfigs */
  listAllSalesforceLeadToRelatedLeadConfigsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/list/all`,
      query,
    );

  /**
   * @description retrieves lead to related lead configs specified by ids
   *
   * @tags CRUD/Matching/RelatedLead
   * @name GetSalesforceLeadToRelatedLeadConfigsByIds
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/matching-config/salesforce-l2rl/list/by-ids
   * @secure
   */
  getSalesforceLeadToRelatedLeadConfigsByIds = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUnderlyingMatchingConfigIdSalesforceRelatedLeadMatchingConfigView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/list/by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSalesforceLeadToRelatedLeadConfigsByIds */
  getSalesforceLeadToRelatedLeadConfigsByIdsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @minItems 1 */
      configIds: string[];
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/matching-config/salesforce-l2rl/list/by-ids`,
      query,
    );
}
